import * as React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

import Homepage from "./page/Homepage/Homepage";
import Signin from "./page/Sigin/Signin";
import ModuleViewer from "./page/ModuleViewer/ModuleViewer";
import ModuleQuiz from "./page/ModuleQuiz/ModuleQuiz";
import ResetPassword from "./page/ResetPassword/ResetPassword";
import SetupPassword from "./page/SetupPassword/SetupPassword";
import RequireAuth from "./auth/RequireAuth";
// import VoiceflowWidget from "./hooks/useVoiceflow";
import ConfirmTicket from "./page/ConfirmTicket/ConfirmTicket";
import { UserProgressProvider } from "./contexts/UserProgressContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Prevent multiple refetches on window focus
      staleTime: 1000 * 60 * 15, // 15 minutes
    },
  },
});

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <UserProgressProvider>
          <Routes>
            <Route path="/login" element={<Signin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/setup-password" element={<SetupPassword />} />
            <Route path="/confirm-ticket" element={<ConfirmTicket />} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Homepage />
                </RequireAuth>
              }
            />
            <Route
              path="/module/:moduleId"
              element={
                <RequireAuth>
                  <ModuleViewer />
                </RequireAuth>
              }
            />
            <Route
              path="/module/:moduleId/quiz"
              element={
                <RequireAuth>
                  <ModuleQuiz />
                </RequireAuth>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </UserProgressProvider>

        {/* Chỉ hiển thị VoiceflowWidget khi user đã đăng nhập và không đang loading */}
        {/* {!loading && user && <VoiceflowWidget />} */}
      </Router>
    </QueryClientProvider>
  );
}
